import { defineMessages } from "react-intl";

import { validator } from "lib/build/forms/ktx/transplantation-screening/lab-procedures/hgbA1CCalculated";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	hgbA1CCalculated: {
		id: "ktx.hgbA1CCalculated.title",
		defaultMessage: "HbA1c (visszaszámolt)"
	},
	value: {
		id: "ktx.hgbA1CCalculated.field.value",
		defaultMessage: "Érték"
	}
});

const fields: { [key: string]: FieldData } = {
	value: {
		type: "field",
		path: ["value"],
		label: messages.value,
		errorMessages: genericErrorMessages,
		input: { type: "input", props: { type: "number" } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.value }] }]
};

export const node: LeafNode = {
	id: "ktx_hgbA1CCalculated",
	value: {
		schemaId: "hgbA1CCalculated",
		title: messages.hgbA1CCalculated,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
